/**


 * @param {string} [projectId] I
 * @returns {void}
 */
export function initClarity(projectId = process.env.REACT_APP_CLARITY_ID) {
  if (!projectId || window.__clarityInitialized) {
    return;
  }

  window.clarity = function clarity() {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  const clarityScript = document.createElement('script');
  clarityScript.async = true;
  clarityScript.src = `https://www.clarity.ms/tag/${projectId}`;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(clarityScript, firstScript);
  } else {
    document.head.appendChild(clarityScript);
  }

  window.__clarityInitialized = true;
}
